import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { REFUNDS_LIST_PATH } from './constants';
var RefundsList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/RefundsList');
});
export var RefundsRouting = function RefundsRouting() {
    return RouteGenerator({
        list: {
            path: REFUNDS_LIST_PATH,
            component: RefundsList,
            exact: true
        }
    });
};
